import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Field } from "./DealsAdmin";

const EMPTY = { destination_name: "", slug: "", country: "", intro: "", best_time_to_visit: "", how_to_get_there: "", where_to_stay: "", points_strategy: "", local_transport: "", budget_tips: "", safety_notes: "", hero_image: "" };

export default function DestinationsAdmin() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/destinations?limit=200").then((r) => setItems(r.data.items));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (editing.id) await api.put(`/destinations/${editing.id}`, editing);
      else await api.post("/destinations", editing);
      toast.success("Saved"); setEditing(null); load();
    } catch { toast.error("Save failed"); }
  };
  const del = async (id) => { if (!confirm("Delete?")) return; await api.delete(`/destinations/${id}`); load(); };

  return (
    <div className="p-8 md:p-10">
      <div className="flex justify-between mb-6">
        <div><div className="overline text-[#B4533C]">Destinations</div><h1 className="font-serif text-4xl mt-1">Destination Guides</h1></div>
        <button onClick={() => setEditing({ ...EMPTY })} className="bg-[#1B3B36] text-white px-5 py-2.5 text-sm" data-testid="new-destination-btn">+ New</button>
      </div>
      <div className="border border-[#D6CFC4]">
        <table className="w-full admin-table"><thead className="bg-[#EFECE5]"><tr><th className="p-3 text-left">Name</th><th className="p-3 text-left">Country</th><th></th></tr></thead><tbody>
          {items.map((d) => (
            <tr key={d.id} className="border-t border-[#D6CFC4]">
              <td className="p-3"><button onClick={() => setEditing(d)} className="hover:text-[#B4533C]">{d.destination_name}</button></td>
              <td className="p-3 text-xs font-mono">{d.country}</td>
              <td className="p-3 text-right"><button onClick={() => del(d.id)} className="text-[#B4533C] text-xs">Delete</button></td>
            </tr>
          ))}
        </tbody></table>
      </div>
      {editing && (
        <div className="fixed inset-0 bg-black/40 z-50 grid place-items-center p-6 overflow-y-auto">
          <div className="bg-white border border-[#D6CFC4] p-8 w-full max-w-3xl max-h-[90vh] overflow-y-auto">
            <h2 className="font-serif text-2xl mb-4">{editing.id ? "Edit" : "New"} Destination</h2>
            <div className="grid md:grid-cols-2 gap-3">
              <Field label="Name" v={editing.destination_name} k="destination_name" e={setEditing} />
              <Field label="Slug" v={editing.slug} k="slug" e={setEditing} />
              <Field label="Country" v={editing.country} k="country" e={setEditing} />
              <Field label="Hero image URL" v={editing.hero_image} k="hero_image" e={setEditing} />
            </div>
            {["intro","best_time_to_visit","how_to_get_there","where_to_stay","points_strategy","local_transport","budget_tips","safety_notes"].map((f) => (
              <div key={f} className="mt-3">
                <label className="overline">{f.replaceAll("_", " ")}</label>
                <textarea value={editing[f] || ""} onChange={(e) => setEditing({ ...editing, [f]: e.target.value })} rows={3} className="w-full border border-[#D6CFC4] px-3 py-2 mt-1 text-sm" />
              </div>
            ))}
            <div className="mt-5 flex gap-3">
              <button onClick={save} className="bg-[#1B3B36] text-white px-5 py-2.5 text-sm" data-testid="save-destination-btn">Save</button>
              <button onClick={() => setEditing(null)} className="border border-[#D6CFC4] px-5 py-2.5 text-sm">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
